__turbopack_context__.v({
  "bufferedBar": "hfOo4a_bufferedBar",
  "centerPlayButton": "hfOo4a_centerPlayButton",
  "controlBar": "hfOo4a_controlBar",
  "controlButton": "hfOo4a_controlButton",
  "controlsGroup": "hfOo4a_controlsGroup",
  "controlsOverlay": "hfOo4a_controlsOverlay",
  "controlsRow": "hfOo4a_controlsRow",
  "playButton": "hfOo4a_playButton",
  "progressBar": "hfOo4a_progressBar",
  "progressBarContainer": "hfOo4a_progressBarContainer",
  "progressBarRow": "hfOo4a_progressBarRow",
  "timeDisplay": "hfOo4a_timeDisplay",
  "videoContainer": "hfOo4a_videoContainer",
  "volumeContainer": "hfOo4a_volumeContainer",
  "volumeSlider": "hfOo4a_volumeSlider",
});
